// extracted by mini-css-extract-plugin
module.exports = {"component":"Cards_component__C5_kq","component__card":"Cards_component__card__fVEfC","component__icon":"Cards_component__icon__yyk9R"};